import React from "react";
import "./About.css";

function About() {
  return (
    <section className="about" id="about">
      <div className="about__text-container">
        <p className="about__text">
          MIKDASH DEVELOPMENT was born from the idea that a home is more than
          just four walls — it’s a place where dreams are made and lived. We
          started with a simple mission: to help people create the perfect space
          where they can feel safe, comfortable, and at peace
        </p>
        <p className="about__text">
          In the beginning, we focused on selling building materials and home
          equipment, but we quickly realized we could offer much more. We
          expanded our range to include everything needed to create a home: from
          doors and windows to kitchen appliances and household electronics.
          Each product in our catalog is carefully selected to ensure high
          quality and durability for our customers
        </p>
        <p className="about__text">
          But we don’t stop at just selling products. Understanding that every
          home is unique, we offer a full range of construction services, from
          design to complete project execution. Our team of experienced
          professionals takes care of every step of the construction and
          renovation process, ensuring that your home meets all your
          expectations
        </p>
        <p className="about__text">
          We take pride in helping our clients bring their dreams to life. At
          MIKDASH DEVELOPMENT, we believe that your home is not just a place to
          live; it’s a space that reflects your individuality and lifestyle. Our
          goal is to make the process of creating your perfect home simple and
          enjoyable by providing everything you need to turn your house into a
          true haven of comfort and harmony
        </p>
        <p className="about__text">
          Join our story, and let us help you create a home that inspires you
          every day
        </p>
      </div>
      <div className="about__title-container">
        <h1 className="about__title" id="destinations">EXPLORE OUR DESTINATIONS</h1>
      </div>
    </section>
  );
}

export default About;
